export const STRIPE_OPTIONS = {
	API_KEY: process.env.STRIPE_API_KEY,
	WEBHOOK_SECRET: process.env.STRIPE_WEBHOOK_SECRET,
}
